import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { cartItem } from '../../../redux-saga/User/Login/Reducer'
import Card from '../../../components/Mobile/ProductCard/Card'
import style from './index.module.css'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'
import { isAddedInCart, handleAddToCart } from '../../../utils/User/helper/functions'

const CardContent = ({ pesticides, additionalClass }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleCartClick = (id) => {
    history.push(`${ ROUTE.PESTICIDEPREVIEW }/${ id }`)
  }

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          {/* <div className='col-2 col-md-2 border mt-3'>Sort By / Relevance</div> */}
          <div className={ `${ additionalClass } col-12 col-md-12 ${ style.flexClass }` }>
            {
              pesticides?.length && pesticides.map((pesticide) => (
                <Card
                  key={ pesticide.id }
                  pesticide={ pesticide }
                  handleAddToCart={ (e) => handleAddToCart(e, pesticide?.id, history, dispatch) }
                  history={ history }
                  isAdded={ isAddedInCart(pesticide) }
                  handleCartClick={ handleCartClick }
                />
              ))
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default CardContent

CardContent.defaultProps = {
  additionalClass: '',
}

CardContent.propTypes = {
  pesticides: PropTypes.arrayOf.isRequired,
  additionalClass: PropTypes.string,
}
